import { Box, Flex, HStack } from '@chakra-ui/react';
import { useState } from 'react';
import { Input } from 'components/UI';
import { IParameter } from '../../../../server/types';

type TextInputSelectableProps = {
  parameter: IParameter;
  paramKey: number;
  value: string;
  onChange(paramKey: number, value: string | boolean, valid: boolean): void;
};

const TextInputSelectable = ({ parameter, paramKey, onChange, value }: TextInputSelectableProps) => {
  const { unit } = parameter;

  const [, setValue] = useState({});

  const handleInputChange = (event: { target: { type: string; checked: boolean; value: string } }) => {
    const { target } = event;
    const newValue = target.type === 'checkbox' ? target.checked : target.value;

    onChange(paramKey, newValue, true);
    setValue({
      value,
    });
  };

  const renderNote = parameter.note !== '' ? <Box py={1}>{parameter.note}</Box> : null;

  const { valueConditions } = parameter;

  const valid = valueConditions ? parameter.valid : true;

  const renderError = !valid ? (
    <Box color="red" pb={1}>
      Please enter a valid parameter.
    </Box>
  ) : null;

  return (
    <Flex
      sx={{
        border: 'solid 1px base2Colour.500',
        color: 'base2FontColour.500',
        fontSize: 'sm',
        fontWeight: 'light',
      }}
    >
      <Flex flex={1} flexDir="column">
        {renderNote}
        {renderError}
        <HStack justifyContent="space-between">
          <Box color="base2FontColour.400" fontSize={14}>
            Enter the value in {unit}:
          </Box>
          <Box>
            <Input
              name={parameter.name}
              value={value}
              onChange={handleInputChange}
              onKeyDown={(event) => {
                if (event.key !== 'Enter') return;
                event.preventDefault();
              }}
              placeholder="0"
              sx={{
                bgColor: 'white',
                w: '100%',
                textAlign: 'right',
                border: 'solid 1px',
                borderColor: 'base2Colour.400',
                borderRadius: 4,
              }}
            />
          </Box>
        </HStack>
      </Flex>
    </Flex>
  );
};

export default TextInputSelectable;
